import { Application, autoDetectRenderer, Container, Rectangle, Graphics} from 'pixi.js';
import {Waveform} from './waveform';
import {TimeIndicator} from './time-indicator';
import {
  TimelineTimestamp,
  PlayerControl,
} from 'storyboard-renderer';
import {StageRenderer} from './stage-renderer'

export class WaveformRenderer {

  public app: Application;
  public stageRenderer: StageRenderer;
  public timelinePositionGetter: Function;

  constructor(outerWidth: number, outerHeight: number, waveData = null, playerControl:PlayerControl, timelineService, audioLength) {
    this.init(outerWidth, outerHeight, waveData, playerControl, timelineService, audioLength);
  }

  protected initApp(outerWidth: number, outerHeight: number): Application{
    return new Application(outerWidth, outerHeight, {backgroundColor : /*0xeff3f6*/0xe3e9ed});
  }

  protected init(outerWidth: number, outerHeight: number, waveData = null, playerControl:PlayerControl, timelineService, audioLength){
    let app = this.initApp(outerWidth, outerHeight);
    this.app = app;
    this.stageRenderer = new StageRenderer(waveData, playerControl, outerWidth, outerHeight, timelineService, audioLength);

    this.app.stage.addChild(this.stageRenderer);

    let self = this;
    app.ticker.add(function(delta?){
      self.stageRenderer.ticker.apply(self.stageRenderer, [delta]);

      if (self.timelinePositionGetter){
        let position = self.timelinePositionGetter();
        self.stageRenderer.position.x = position;
      }
    });

  }

  public setTimelinePositionGetter(value: Function){
    this.timelinePositionGetter = value;
    if (this.stageRenderer){
      this.stageRenderer.setTimelinePositionGetter(value);
    }
  }
  public setTimelinePositionSetter(value: Function){
    if (this.stageRenderer){
      this.stageRenderer.setTimelinePositionSetter(value);
    }
  }

  public setPlayerControl(value:PlayerControl){
    this.stageRenderer.setPlayerControl(value);
  }
  public getPlayerControl():PlayerControl{
    return this.stageRenderer.getPlayerControl();
  }

  public setSize(width: number, height: number){
    this.app.renderer.resize(width, height);
    this.app.renderer.view.style.width = width+"px";
    this.app.renderer.view.style.height = height+"px";
    this.stageRenderer.setSize(width, height);
  }

  public setInnerWidth(value: number){
    this.stageRenderer.setInnerWidth(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/audio-track/waveform/waveform-renderer/index.ts